import { Fragment } from "react";
import { Button, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getPlan, getPlanData } from "../../../../../redux/Sections/PlanesDePago/actions";


export const Deudas = ({ data }) => {
  const dispatch = useDispatch();
  const history = useHistory();


  const handleClick = async () => {
    if (data) {
      dispatch(getPlan(data.planpago));
      dispatch(getPlanData({ ...data.contribuyente, RECURSO: data.recurso, IMPONIBLE: data.imponible }));
      history.push(`./plan-de-pago/${data.id}`);
    }
  };

  return (
    <>
      {data?.deudas?.en_gestion?.deudas && data?.deudas?.en_gestion?.deudas?.length ? <Table className="subtable" striped bordered hover>
        <tbody>
          <tr>
            <td colSpan={3} className="subtable-subtitulo">Períodos FURLANO, GUSTAVO MARTIN (A08) en Gestión Legal</td>
          </tr>
          <tr>
            <td className="subtable-key">Año</td>
            <td className="subtable-key">Período</td>
            <td className="subtable-key">Monto</td>
          </tr>
          {data.deudas?.en_gestion?.deudas?.length && data.deudas.en_gestion.deudas.map((deuda, i) => {
            return <Fragment key={"deudas1-" + i}>
              <tr>
                <td><span>{deuda.age}</span></td>
                <td><span>{deuda.periodos.map((p, i) => (i !== deuda.periodos.length - 1) ? p + ", " : p)}</span></td>
                <td><span>{deuda.monto}</span></td>
              </tr>
            </Fragment>;
          })
          }
          <tr>
            <td className="subtable-key">Total</td>
            <td></td>
            <td className="subtable-key">{data.deudas.en_gestion.total}</td>
          </tr>
        </tbody>
      </Table> : null}
      <br />
      {data?.deudas?.fuera_gestion?.deudas && data?.deudas?.fuera_gestion?.deudas?.length ? <Table className="subtable" striped bordered hover>
        <tbody>
          <tr>
            <td colSpan={3} className="subtable-subtitulo">Períodos Fuera de Gestión Legal</td>
          </tr>
          <tr>
            <td className="subtable-key">Año</td>
            <td className="subtable-key">Período</td>
            <td className="subtable-key">Monto</td>
          </tr>
          {data.deudas.fuera_gestion.deudas.length && data.deudas.fuera_gestion.deudas.map((deuda, i) => {
            return <Fragment key={"deudas2-" + i}>
              <tr>
                <td><span>{deuda.age}</span></td>
                <td><span>{deuda.periodos.map((p, i) => (i !== deuda.periodos.length - 1) ? p + ", " : p)}</span></td>
                <td><span>{deuda.monto}</span></td>
              </tr>
            </Fragment>;
          })
          }
          <tr className="">
            <td className="subtable-key"><span>Total</span></td>
            <td></td>
            <td className="subtable-key d-flex"><span style={{ width: "100%" }}>{data.deudas.fuera_gestion.total}</span>
              <span style={{ width: "100%" }}><Button onClick={handleClick}>Ver Plan de Pago</Button></span>
            </td>
          </tr>
        </tbody>
      </Table> : null}
    </>
  );
};